export class AccountRulesPrefix {
  private enabledGroups: string[];

  constructor(enabledGroups: string[]) {
    this.enabledGroups = enabledGroups || [];
  }

  digitsFrom(value: string | number | null | undefined): string {
    const raw = value == null ? '' : String(value);
    return raw.trim().replace(/\D/g, '');
  }

  getMessage(value: string | number | null | undefined): string {
    const inputText = this.digitsFrom(value);

    if (this.enabledGroups == null || (Array.isArray(this.enabledGroups) && this.enabledGroups.length === 0)) return ''

    if (this.enabledGroups.includes('7') && inputText.startsWith('7')) {
      return '¡Atención! Se ha informado una cuenta del grupo 7 como cuenta de gasto.';
    }
    if (this.enabledGroups.includes('6') && inputText.startsWith('6')) {
      return '¡Atención! Se ha informado una cuenta del grupo 6 como cuenta de ingreso.';
    }
    if ((this.enabledGroups.includes('43') || this.enabledGroups.includes('44')) &&
        (inputText.startsWith('43') || inputText.startsWith('44'))) {
      return '¡Atención! Se ha informado una cuenta del grupo 43/44 como cuenta de proveedor.';
    }
    if ((this.enabledGroups.includes('40') || this.enabledGroups.includes('41')) &&
        (inputText.startsWith('40') || inputText.startsWith('41'))) {
      return '¡Atención! Se ha informado una cuenta del grupo 40/41 como cuenta de cliente.';
    }
    return '';
  }
}